(function($) {
    // Function to toggle search visibility
    function toggleSearchOpen() {
        $('.mobile-search').addClass('is-active');
        $('.mobile-search').removeClass('d-xl-none');
        $('.nav-search-icon').addClass('close-icon');
        $('.main-nav .navbar-nav').addClass('not-active');

        // Focus on the search input when opened (accessibility improvement)
        setTimeout(function() {
            $('#mobile-search').focus();
        }, 100);
    }

    // Toggle search on icon click
    $('.nav-search-icon').on('click', function(e) {
        toggleSearchOpen();
        e.stopPropagation();
    });

    // Toggle search on Enter key when search icon is focused
    $('.nav-search-icon').on('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            toggleSearchOpen();
            e.preventDefault();
            e.stopPropagation();
        }
    });

    // Your existing code to close search when clicking outside
    $('body').on('click', function(e) {
        var searchIcon = $('.mobile-search');

        if(searchIcon !== event.target && !searchIcon.has(event.target).length){
            $('.mobile-search').removeClass('is-active');
            $('.mobile-search').addClass('d-xl-none');
            $('.nav-search-icon').removeClass('close-icon');
            $('.main-nav .navbar-nav').removeClass('not-active');
        }
    });

    // Additional accessibility improvements

    // Submit search on Enter key in search field
    $('#mobile-search').on('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            $(this).closest('form').submit();
        }
    });

    // Close search on Escape key
    $(document).on('keydown', function(e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && $('.mobile-search').hasClass('is-active')) {
            $('.mobile-search').removeClass('is-active');
            $('.mobile-search').addClass('d-xl-none');
            $('.nav-search-icon').removeClass('close-icon');
            $('.main-nav .navbar-nav').removeClass('not-active');

            // Return focus to search icon
            $('.nav-search-icon').focus();
        }
    });

})(jQuery);